import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  role: string = '';
  isHandset: boolean = false;

  // Modo drawer/hamburguesa para móviles y tablets (< 992px, estándar LG)
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(['(max-width: 991.98px)'])
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  opened: boolean = true;

  constructor(private router: Router, private breakpointObserver: BreakpointObserver, private authService: AuthService) { }

  ngOnInit(): void {
    this.isHandset$.subscribe(isHandset => {
      this.isHandset = isHandset;
      this.opened = !isHandset;
    });
  }

  onNavClick(sidenav: any): void {
    if (this.isHandset && sidenav) {
      sidenav.close();
    }
  }
  getUserInitials(): string {
    let dataUser = this.authService.getUserData();
    if (dataUser === null || dataUser === undefined) {
      this.router.navigate(['/login/login']);
      return
    }
    this.role = dataUser?.data_user?.role;
    const names = dataUser.data_user.name.split(" ");
    const initials = names[0][0] + (names[1] ? names[1][0] : '');
    return initials.toUpperCase();
  }

  changePassword() {
    // Lógica para cambiar la clave
  }


  logout() {
    // Lógica para cerrar sesión
    Swal.fire({
      title: '¿Estás seguro que deseas cerrar sesión?',
      text: "",
      showCancelButton: true,
      confirmButtonColor: '#1C37BA',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Cerrar sesión',
      showClass: {
        popup: `
      animate__animated
      animate__fadeInUp
      animate__faster
    `,
      },
    }).then((option) => {
      if (option.isConfirmed) {
        this.authService.logout();
      }
    });
  }
}
